import { css } from "@emotion/react";
import { useTheme } from "../theme";
import { WeeklyCalendarRenderCellProps } from "./WeeklyCalendar";

export interface WeeklyCalendarColumnType<T> {
  date: Date;
  dateStr: string;
  isToday: boolean;
  index: number;
  rows: T[];
  renderCell: (props: WeeklyCalendarRenderCellProps<T>) => React.JSX.Element;
}

export interface WeeklyCalendarRenderColumnProps<
  T,
> extends WeeklyCalendarColumnType<T> {
  children: React.ReactNode;
  rootRef?: React.RefObject<HTMLDivElement | null>;
  renderCell: (props: WeeklyCalendarRenderCellProps<T>) => React.JSX.Element;
}

export const WeeklyCalendarColumn = <T,>({
  isToday,
  children,
  rootRef,
}: Partial<WeeklyCalendarRenderColumnProps<T>>) => {
  const theme = useTheme();
  return (
    <div
      // React v19ではnullを許容するが、v18では許容されないため、完全にReact v18サポートを切るまで型を無効化する
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ref={rootRef}
      css={[
        css`
          box-sizing: border-box;
          background-color: white;
          border-left: 1px solid #c5c5c5;
          &:nth-child(7n) {
            border-right: 1px solid #c5c5c5;
          }
        `,
        isToday
          ? css`
              border: 1px solid ${theme.palette.intentions.primary.main};
              & + div {
                border-left-style: none;
              }
            `
          : null,
      ]}
    >
      {children}
    </div>
  );
};
